import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import api from '../services/apiClient';

const useAuthStore = create(
  persist(
    (set, get) => ({
      user: null,
      isAuthenticated: false,
      loading: true,
      companies: [],
      currentCompany: null,

      login: async (email, password) => {
        const data = await api.post('/auth/login', { email, password });
        api.setToken(data.token);
        api.setRefreshToken(data.refreshToken);
        set({ user: data.user, isAuthenticated: true, loading: true });
        await get().loadProfile();
      },

      register: async (name, email, password) => {
        const data = await api.post('/auth/register', { name, email, password });
        api.setToken(data.token);
        api.setRefreshToken(data.refreshToken);
        set({ user: data.user, isAuthenticated: true, loading: true });
        await get().loadProfile();
      },

      logout: () => {
        api.setToken(null);
        api.setRefreshToken(null);
        api.setCompanyId(null);
        set({ user: null, isAuthenticated: false, companies: [], currentCompany: null, loading: false });
      },

      loadProfile: async () => {
        try {
          const data = await api.get('/auth/profile');
          const companies = data.companies || [];
          const savedId = localStorage.getItem('mkt_company_id');
          const currentCompany =
            companies.find((c) => String(c.id) === String(savedId)) ||
            companies.find((c) => c.isDefault) ||
            companies[0] ||
            null;

          if (currentCompany) api.setCompanyId(currentCompany.id);

          set({
            user: data.user,
            isAuthenticated: true,
            companies,
            currentCompany,
            loading: false
          });
        } catch {
          const hasToken = !!localStorage.getItem('mkt_token');
          set({ loading: false, isAuthenticated: hasToken ? get().isAuthenticated : false });
        }
      },

      switchCompany: (companyId) => {
        const company = get().companies.find((c) => c.id === companyId);
        if (company) {
          api.setCompanyId(companyId);
          set({ currentCompany: company });
        }
      },

      // Recarrega a lista de empresas (apos criar/editar)
      reloadCompanies: async () => {
        await get().loadProfile();
      }
    }),
    {
      name: 'mkt-auth-storage',
      partialize: (state) => ({
        user: state.user,
        isAuthenticated: state.isAuthenticated,
        companies: state.companies,
        currentCompany: state.currentCompany
      })
    }
  )
);

export default useAuthStore;
